export const extractCustomerTaxFromTotalTax = (increasedValue, percentage) => {
  let originalValue = increasedValue / (1 + percentage / 100);
  let increaseAmount = increasedValue - originalValue;
  return Math.round(increaseAmount);
};
